export default __webpack_public_path__ + "static/media/ARTIST-06 (1-1).fbf80b48.jpg";